/* eslint-disable import/no-duplicates */
import { styled } from '@atom-web/core'
import Right from '@atom-web/icons-24/Right'
import { Box, Column, Flex, Row, Text } from '@atom-web/micros'
import Image from 'next/image'
import { useRouter } from 'next/router'

import getImgIXUrl from '../../../../utils/getImgIXUrl'

const ImageGradiant = styled(Box, {
	position: 'absolute',
	left: 0,
	top: 0,
	backgroundColor: 'transparent',
	width: '100%',
	height: '100%',
	zIndex: -1,

	'&::before': {
		position: 'absolute',
		top: 0,
		left: 0,
		content: '',
		background:
			'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 8%,rgba(0, 0, 0, 0) 29%)',
		width: '100%',
		height: '100%',
	},

	'&::after': {
		width: '100%',
		height: '64px',
		position: 'absolute',
		top: 0,
		left: 0,
		content: '',
		background:
			'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 8%,rgba(0, 0, 0, 0) 29%)',
	},
})

export default ({ data = [], isMobile, loader, slug, route }) => {
	const router = useRouter()

	const onClickGallery = ({ index = 0, route }) => {
		router.push(`/${slug}?gallery=${route}&index=${index}`, null, {
			shallow: true,
			scroll: false,
		})
	}

	if (!data.length) return null

	return (
		<Flex
			css={{
				width: '100%',
				gap: '1',
			}}
		>
			<Row
				css={{
					width: '100%',
					flexWrap: 'wrap',
					gap: 4,
				}}
			>
				{data
					?.filter((_, inx) => (isMobile ? inx < 2 : inx < 6))
					.map((value, index, self) => {
						if (value?.images?.[0]) {
							return (
								<Box
									css={{
										position: 'relative',
										cursor: 'pointer',
										overflow: 'hidden',
										borderRadius: '3px',
										'@lg': {
											width: 'calc(33.33% - 4px)',
											height: '240px',
										},
										'@smMax': {
											width: 'calc(50% - 4px)',
											height: '168px',
										},
									}}
									key={'room-details-image' + index}
									onClick={() => onClickGallery({ index, route })}
								>
									<Image
										unoptimized
										objectFit="cover"
										src={getImgIXUrl(
											value?.images?.[0],
											'h=240&w=240&fit=crop',
											80,
											2,
										)}
										layout="fill"
										className="room-grid"
										alt={value?.name}
										loader={loader}
									/>
									<ImageGradiant />
									{(!isMobile &&
										self.length > 5 &&
										index === self.length - 1) ||
									(isMobile && self.length > 1 && index === self.length - 1) ? (
										<Column
											css={{
												position: 'absolute',
												height: '100%',
												width: '100%',
												zIndex: 1,
												background:
													'linear-gradient(180deg,transparent,rgba(0,0,0,.60))',
											}}
										>
											{data.length - (isMobile ? 1 : 5) > 0 && (
												<Text
													css={{
														color: '$white',
														fontSize: '26px',
														fontWeight: '$bolder',
														position: 'absolute',
														bottom: 24,
														paddingLeft: 12,
														paddingBottom: 12,
														paddingTop: 12,
													}}
												>
													+{data.length - (isMobile ? 1 : 5)}
												</Text>
											)}
											<Text
												css={{
													color: '$white',
													fontSize: '15px',
													fontWeight: '$bolder',
													position: 'absolute',
													bottom: 0,
													paddingLeft: 12,
													paddingBottom: 12,
													paddingTop: 12,
													zIndex: 10,
													width: '100%',
													background:
														'linear-gradient(180deg,transparent,rgba(0,0,0,.60))',
												}}
											>
												{!isMobile
													? self.length > 5
														? 'View All'
														: value?.name
													: self.length > 1
													? 'View All'
													: value?.name}
												{data.length - (isMobile ? 1 : 5) > 0 && (
													<Right
														width={22}
														height={22}
														css={{
															marginLeft: 4,
															fill: '$white',
														}}
													/>
												)}
											</Text>
										</Column>
									) : (
										<Text
											css={{
												position: 'absolute',
												bottom: 0,
												left: 0,
												width: '100%',
												paddingLeft: 12,
												paddingBottom: 16,
												paddingTop: 16,
												color: '$white',
												fontSize: '15px',
												fontWeight: '$bolder',
												zIndex: 10,
												background:
													'linear-gradient(180deg,transparent,rgba(0,0,0,.60))',
											}}
										>
											{value.name}
										</Text>
									)}
								</Box>
							)
						}

						return null
					})}
			</Row>
		</Flex>
	)
}
